import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

export const referralKeys = {
  all: ['referrals'] as const,
  attribution: () => [...referralKeys.all, 'attribution'] as const,
};

/**
 * How referrals were attributed across every inviter in the last 30 days: a
 * count for every source, and the referrals themselves, newest first.
 */
export function useReferralAttribution() {
  return useQuery({
    queryKey: referralKeys.attribution(),
    queryFn: () => adminClient.summarizeReferralAttribution(),
  });
}
